export default "__VITE_ASSET__CWCIWObP__"